import { styled } from '@mui/material/styles';

/** Solid-bordered grey `<pre>` for a wrapped, scrollable code or JSON dump. */
export const CodeListing = styled('pre')(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  overflow: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  backgroundColor: theme.palette.grey[100],
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace',
  fontSize: '0.875rem',
  lineHeight: 1.5,
}));
